export default "__VITE_ASSET__ffde70e9__"